import React from 'react';
import { Tabs } from '../Tabs/Tabs.tsx';
import { useContainerQuery } from '../../hooks/useContainerQuery.ts';
import styles from './PageTabs.module.scss';
const CONTENT_MAX_WIDTH_PX = 1100;
const NARROW_BREAKPOINT_PX = 600;
const query = {
    isNarrow: {
        maxWidth: NARROW_BREAKPOINT_PX
    },
    isPortrait: {
        orientation: 'portrait'
    }
};
const PageTabsComponent = ({ activeTabId, onTabChange, variant, scrollDirection, children })=>{
    const [{ isNarrow, isPortrait }, contentRef] = useContainerQuery(query);
    const shouldCollapseText = isNarrow && variant == 'iconAndText';
    const resolvedVariant = shouldCollapseText ? 'iconOnly' : variant;
    const tabPosition = isNarrow && isPortrait ? 'top' : 'left';
    return /*#__PURE__*/ React.createElement("div", {
        ref: contentRef,
        className: styles.container
    }, /*#__PURE__*/ React.createElement(Tabs, {
        activeTabId: activeTabId,
        onTabChange: onTabChange,
        variant: resolvedVariant,
        scrollDirection: scrollDirection,
        tabPosition: tabPosition,
        maxWidth: CONTENT_MAX_WIDTH_PX
    }, children));
};
/** Tabs preset for content pages. */ export const PageTabs = Object.assign(PageTabsComponent, {
    Tab: Tabs.Tab
});
